import { merge } from "lodash";
import addressModuleActions from "./addressModule/actions";
import shipmentModuleActions from "./shipmentModule/actions";

export default merge(addressModuleActions, shipmentModuleActions);
